export default "/images/a44f08ed6f0deb5fdfc5d7810ee3031b.avif";